import { storage } from '@otto-ec/global-resources/storage';

export function getSessionStorage(): ReturnType<typeof storage> {
    return storage(() => window.sessionStorage);
}
